import { Alert } from '@mantine/core';
import { useAuthStore } from '@/store/auth';
import { ReactNode } from 'react';

interface PermissionGuardProps {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export default function PermissionGuard({ permission, children, fallback }: PermissionGuardProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission);

  if (!hasPermission || !hasPermission(permission)) {
    return fallback ? <>{fallback}</> : <Alert color="red">You do not have permission to access this section.</Alert>;
  }

  return <>{children}</>;
}
